"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartActionTypes = void 0;
var CartActionTypes;
(function (CartActionTypes) {
    CartActionTypes["ADD_ITEM"] = "ADD_ITEM";
    CartActionTypes["REMOVE_ITEM"] = "REMOVE_ITEM";
    CartActionTypes["UPDATE_ITEM_QUANTITY"] = "UPDATE_ITEM_QUANTITY";
    CartActionTypes["SET_CART_DATA"] = "SET_CART_DATA";
    CartActionTypes["SET_STRATEGY"] = "SET_STRATEGY";
    CartActionTypes["SET_CART_ITEMS"] = "SET_CART_ITEMS";
    CartActionTypes["SET_ORDER_ID"] = "SET_ORDER_ID";
    CartActionTypes["CLEAR_CART"] = "CLEAR_CART";
    CartActionTypes["LOADING_CART"] = "LOADING_CART";
    CartActionTypes["LOADED_CART"] = "LOADED_CART";
    CartActionTypes["ERROR"] = "ERROR";
    // TODO - Refatorar para existir um Context somente dos dados de reseller e ciclo e não misturar com o carrinhoq
    CartActionTypes["SET_META_DATA"] = "SET_META_DATA";
})(CartActionTypes = exports.CartActionTypes || (exports.CartActionTypes = {}));
